'use client';

import { isString } from 'lodash';
import { useParams } from 'next/navigation';

export const useURLWorkspaceId = (): string | undefined => {
  const params = useParams();

  if (!params) {
    return undefined;
  }
  const value = params.workspaceId;

  return isString(value) ? value : undefined;
};
